import { createFileRoute } from "@tanstack/react-router";
import { requireMinRole } from "@/lib/route-guards";
import { ScopeOfWorksPage } from "@/sections/scope-of-works/page";

function ScopeOfWorksRoute() {
  return <ScopeOfWorksPage />;
}

export const Route = createFileRoute("/dashboard/scope-of-works/")({
  component: ScopeOfWorksRoute,
  beforeLoad: ({ context }) => {
    // Viewers get read-only access (CTE-130): the sidebar "Scopes of Work"
    // section and `GET /api/scope-of-works` are already available to viewers,
    // and the page hides every mutation behind a manager-floor check, so the
    // route must agree and not bounce the viewer away.
    requireMinRole(context.session, "viewer");
  },
  staticData: {
    title: "Scope of Works",
  },
});
